import { ConversationActionsProvider } from "@circle-react/components/CircleAi/Home/ConversationActions/ConversationActionsProvider";
import { ConversationActionsTrigger } from "@circle-react/components/CircleAi/Home/ConversationActions/ConversationActionsTrigger";
import { Icon } from "@circleco/compass/components/Icon";
import { Typography } from "@circleco/compass/components/Typography";

import { t } from "@/i18n-js/instance";

import { CARD_ACTIONS_REVEAL_CLASSES } from "../Home/constants";
import { useRecentChatsList } from "../Home/RecentChatsDrawer/useRecentChatsList";
import { useCircleAiStore } from "../useCircleAiStore";
import { useOpenRecentChat } from "../useOpenRecentChat";
import { DOCK_NAV_ROW_CLASSES } from "./constants";

const VISIBLE_CHATS_LIMIT = 3;
export const RECENT_CHATS_FETCH_LIMIT = VISIBLE_CHATS_LIMIT + 1;

export const CircleAIDockRecentChatsSectionContent = () => {
  const openRecentChat = useOpenRecentChat();
  const setDockRecentChatsOpen = useCircleAiStore(
    s => s.setDockRecentChatsOpen,
  );

  const { data } = useRecentChatsList({
    query: "",
    perPage: RECENT_CHATS_FETCH_LIMIT,
  });
  const fetchedConversations = data?.pages.flatMap(page => page.records) ?? [];
  const conversations = fetchedConversations.slice(0, VISIBLE_CHATS_LIMIT);

  if (conversations.length === 0) return null;

  const shouldShowMoreButton =
    fetchedConversations.length > VISIBLE_CHATS_LIMIT;

  return (
    <ConversationActionsProvider>
      <div className="flex flex-col gap-0.5 px-3 py-2">
        <Typography
          variant="heading-xs"
          color="tertiary"
          component="h2"
          className="px-3 pb-1 pt-2"
        >
          {t("circle_ai_dock.sections.recent_chats")}
        </Typography>
        {conversations.map(conversation => (
          <div
            key={conversation.uuid}
            className="group flex items-center rounded-md transition-colors duration-150 ease-linear hover:bg-active hover:text-selector-active"
          >
            <button
              type="button"
              onClick={() =>
                openRecentChat(
                  conversation.uuid,
                  conversation.title,
                  conversation.project_id,
                )
              }
              className="flex h-9 min-w-0 flex-1 items-center gap-3 rounded-md px-3 py-2 text-left"
            >
              <Icon
                name="clock-dash"
                color="primary"
                size="md"
                className="shrink-0"
              />
              <Typography variant="body-sm" className="truncate">
                {conversation.title ?? t("circle_ai_home.new_conversation")}
              </Typography>
            </button>
            <div className={`shrink-0 pr-1.5 ${CARD_ACTIONS_REVEAL_CLASSES}`}>
              <ConversationActionsTrigger
                conversation={{
                  uuid: conversation.uuid,
                  title: conversation.title,
                  projectUuid: conversation.project_id,
                  isDailyBriefConversation:
                    conversation.daily_brief_conversation,
                }}
              />
            </div>
          </div>
        ))}
        {shouldShowMoreButton && (
          <button
            type="button"
            onClick={() => setDockRecentChatsOpen(true)}
            className={DOCK_NAV_ROW_CLASSES}
          >
            <Icon
              name="dot-menu"
              color="primary"
              size="md"
              className="shrink-0"
            />
            <Typography variant="body-sm" truncate>
              {t("circle_ai_dock.recent_chats.more")}
            </Typography>
          </button>
        )}
      </div>
    </ConversationActionsProvider>
  );
};
